import React from 'react';

import Button from '@amzn/meridian/button';
import Row from '@amzn/meridian/row';
import DebounceSearchField from 'src/components/shared/debounceSearchField/debounceSearchField';
import {
  setIsTaskGroupModalOpen,
  setTaskGroupSearchFieldValue,
} from 'src/store/adminConfigPageSlice/taskConfigPageSlice/taskConfigPageSlice';
import { useAppDispatch, useAppSelector } from 'src/store/store';

// **** Components **** //

/**
 * Default component
 */
const TopOptions = () => {
  const dispatch = useAppDispatch();
  const { taskGroupSearchFieldValue } = useAppSelector((state) => state.taskConfigPage);

  return (
    <Row widths={['92.5%', '7.5%']} spacingInset="400 none" alignmentHorizontal="justify">
      <Row width="grid-4">
        <DebounceSearchField
          value={taskGroupSearchFieldValue}
          onDebounce={(v) => dispatch(setTaskGroupSearchFieldValue(v))}
          placeholder="Search for..."
        />
      </Row>
      <Button onClick={() => dispatch(setIsTaskGroupModalOpen(true))}>Add Group</Button>
    </Row>
  );
};

// **** Export **** //

export default TopOptions;
